import TeaserMap from './TeaserMap';
export default TeaserMap